// TODO types
import type { AnyObject } from '../../types';

export const BOT_NAME = process.env.NODE_ENV === 'production' ? 'vdeloDudeBot' : 'vdeloDudeLocalBot';

/** Максимум изображений у задачи (файлы и вставки в описание делят один лимит) */
export const MAX_TASK_IMAGES = 10;
/** Максимум видео у задачи */
export const MAX_TASK_VIDEOS = 3;
/** Максимум изображений у комментария */
export const MAX_COMMENT_IMAGES = 5;

export const MAX_TASK_IMAGE_MB = 10;
export const MAX_TASK_VIDEO_MB = 50;
export const MAX_TODO_REPORT_MB = 50;

export const MAX_TASK_IMAGES_MESSAGE = `К задаче можно прикрепить не больше ${MAX_TASK_IMAGES} изображений`;
export const MAX_TASK_VIDEOS_MESSAGE = `К задаче можно прикрепить не больше ${MAX_TASK_VIDEOS} видео`;

// MQTT over WebSocket
export const MQTT_HOST = process.env.REACT_APP_MQTT_HOST!;
export const MQTT_LOGIN = process.env.REACT_APP_MQTT_LOGIN!;
export const MQTT_PASSWORD = process.env.REACT_APP_MQTT_PASSWORD!;
export const MQTT_TOPIC = process.env.REACT_APP_MQTT_TOPIC!;

export const GIPHY_API_KEY = process.env.REACT_APP_GIPHY_API_KEY || '';

export const BREAKPOINTS = {
    XS: 480,
    SM: 640,
    MD: 768,
    LG: 1024,
    XL: 1280,
    XXL: 1536,
};

export const TASK_STATUS: any = {
    1: 'Открыт',
    2: 'В работе',
    3: 'Исправлен',
    4: 'Проверка',
    5: 'Закрыт',
    6: 'Отклонён',

    open:      1,
    inWork:    2,
    fixed:     3,
    check:     4,
    closed:    5,
    rejected:  6,
};

export const SUPPORT_TAGS = {
    frontend: 'Баг Фронтенда',
    backend: 'Баг Бекэнда',
    question: 'Вопрос',
    task: 'Задача',
    other: 'Другое',
};

export const USER_ROLES: any = {
    1: 'Владелец',
    2: 'Тестировщик',
    3: 'Разработчик',
    4: 'Сопровождающий',
    5: 'Планировщик',

    owner:      1,
    tester:     2,
    developer:  3,
    maintainer: 4,
    planner:    5,
};

export const PROJECT_TYPES = {
    1: 'Приватный',
    2: 'Публичный',

    private: 1,
    public:  2,
};

export const TODO_ACTIVITY_TYPES: any = {
    1: 'Добавление задачи',
    2: 'Изменение задачи',
    3: 'Удаление задачи',
    4: 'Удаление изображения',
    5: 'Добавление изображения',
    6: 'Обновление статуса',
    7: 'Обновление тегов',
    8: 'Добавление ссылки',
    9: 'Удаление ссылки',
    10: 'Добавление комментария',
    11: 'Изменение приоритета',
    12: 'Изменение комментария',

    addTask:        1,
    updateTask:     2,
    deleteTask:     3,
    deleteImage:    4,
    addImage:       5,
    updateStatus:   6,
    updateTags:     7,
    addLink:        8,
    deleteLink:     9,
    addComment:     10,
    updatePriority: 11,
    updateComment:  12,
};

export const PRIORITIES: AnyObject = {
    1: 'Тривиальный уровень',
    2: 'Незначительный уровень',
    3: 'Серьёзный уровень',
    4: 'Критический уровень',
    5: 'Блокирующий уровень',

    trivial:  1,
    minor:    2,
    major:    3,
    critical: 4,
    blocker:  5,
};
